import type { NetworkIdentity } from './contracts';

export const NETWORK_IDENTITY_STORAGE_KEY = 'towerarena.com.network-identity';

export function loadNetworkIdentity(storage: Pick<Storage, 'getItem'>): NetworkIdentity | null {
  try {
    const raw = storage.getItem(NETWORK_IDENTITY_STORAGE_KEY);
    if (!raw) return null;
    const value = JSON.parse(raw) as Partial<NetworkIdentity>;
    if (value.schemaVersion !== 1 || typeof value.networkPlayerId !== 'string' || !value.networkPlayerId || typeof value.playerTicket !== 'string' || value.playerTicket.length < 32) return null;
    return value as NetworkIdentity;
  } catch { return null; }
}

export function saveNetworkIdentity(storage: Pick<Storage, 'setItem'>, identity: NetworkIdentity): boolean {
  try { storage.setItem(NETWORK_IDENTITY_STORAGE_KEY, JSON.stringify(identity)); return true; }
  catch { return false; }
}
